import { render, staticRenderFns } from "./ContactEmployee.vue?vue&type=template&id=90404d92"
import script from "./ContactEmployee.vue?vue&type=script&lang=ts"
export * from "./ContactEmployee.vue?vue&type=script&lang=ts"
import style0 from "./ContactEmployee.vue?vue&type=style&index=0&id=90404d92&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QImg,QBtn});
